// extracted by mini-css-extract-plugin
module.exports = {"modal":"InvoicePreviewModal_modal__quNT-","pdf-viewer":"InvoicePreviewModal_pdf-viewer__2t3V5","pdfViewer":"InvoicePreviewModal_pdf-viewer__2t3V5"};